<button mat-raised-button class="accentBgColor_300" [disabled]="listOrMaps === 'list' " (click)="toggleListOrMaps('list')">
  <mat-icon>list</mat-icon>
</button>
<button mat-raised-button class="accentBgColor_300" title="{{mapAvailableMessage}}" [disabled]="listOrMaps === 'map' || !mapAvailable" (click)="toggleListOrMaps('map')">
  <mat-icon>map</mat-icon>
</button>
